<template>
    <b-overlay :show="loading" opacity="0.2">
        <div class="container">
            <div class="col-md-12">
                <div class="invoice">
                    <div class="font-weight-bolder d-flex align-items-center justify-content-between">
                        <h1 class="mb-0">{{$param('company.name') || '-'}} - Dekont</h1>
                        <span class="d-print-none">
                            <button class="btn btn-sm btn-white" v-on:click="print">
                                <feather-icon icon="PrinterIcon" class="mr-50"></feather-icon>
                                Yazdır
                            </button>
                        </span>
                    </div>
                    <div class="invoice-header">
                        <div class="invoice-from">
                            <small>Ödeme Bilgileri</small>
                            <address class="mt-2 mb-2">
                                <strong>Cari İsmi: {{$safe(receipt,'CariName') || '-'}}</strong><br>
                                <strong>Ödeme Yapılan Banka: {{$safe(receipt,'Bank') || '-'}}</strong><br>
                                <strong>Kart Üzerindeki İsim: {{$safe(receipt,'CardHolderName') || '-'}}</strong><br>
                            </address>
                        </div>
                        <div class="invoice-date">
                            <small>&nbsp;</small>
                            <div class="date text-inverse mt-2">{{$safe(receipt,'PaymentTime') || '-'}}</div>
                        </div>
                    </div>
                    <div class="invoice-content">
                        <div class="table-responsive">
                            <table class="table table-invoice table-bordered" v-if="($safe(receipt,'Details') || []).length">
                                <thead>
                                    <tr>
                                        <th class="w-25">Fatura Numarası</th>
                                        <th class="w-15">Fatura Kesim Tarihi</th>
                                        <th class="w-15">Ödeme Tarihi</th>
                                        <th class="w-15">Toplam Ödenmiş Tutar (TL)</th>
                                        <th class="w-15">Kalan Tutar (TL)</th>
                                        <th class="w-15">Toplam Tutar (TL)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(detail,index) in receipt.Details.filter(d=> d.Status != 7  &&  d.Status != 8)" :key="index">
                                        <td>{{$safe(detail,'DocumentNo') || '-'}}</td>
                                        <td>{{$safe(detail,'Date') || '-'}}</td>
                                        <td>{{$safe(detail,'LastUpdateTime') || '-'}}</td>
                                        <td class="text-right">{{$safe(detail,'PaidPart') || '-'}}</td>
                                        <td class="text-right">{{$safe(detail,'RemainingDebt') || '-'}}</td>
                                        <td class="text-right">{{$safe(detail,'Debt') || '-'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="invoice-price">
                            <div class="invoice-price-left">
                                <div class="invoice-price-row">
                                </div>
                            </div>
                            <div class="invoice-price-right">
                                <template v-if="commissionAmount">
                                    <h5>BANKA KOMİSYON TUTARI</h5>
                                    <span class="font-weight-bolder">{{ commissionAmount }}₺</span>
                                    <h5 class="mt-1">TUTAR</h5>
                                    <span class="font-weight-bolder">{{$safe(receipt,'Amount') || '-'}}₺</span>
                                    <hr/>
                                </template>
                                <h4>ÖDENEN TUTAR</h4> <span class="font-weight-bolder">{{$safe(receipt,'TotalAmount') || '-'}}₺</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-right d-print-none">
                        <h5 class="text-warning">Ödeme işlemini tamamladıysanız sayfayı kapatabilirsiniz. Eğer tamamlamadıysanız "Ödemeye Devam Et" butonu ile işleme devam edebilirsiniz.</h5>
                        <button class="btn btn-sm btn-primary" v-on:click="continuePayment">
                            Ödemeye Devam Et
                            <feather-icon icon="ArrowRightIcon" class="ml-50"></feather-icon>
                        </button>
                    </div>
                    <div class="invoice-note">
                        * Bu faturayla ilgili herhangi bir sorunuz varsa <a :href="`mailto:${mailAddress}`">{{mailAddress}}</a> adresinden ulaşabilirsiniz.
                    </div>
                    <div class="invoice-footer d-print-none">
                        <p class="text-center mb-2 font-weight-bolder">
                            Teşekkür ederiz
                        </p>
                        <p class="text-center">
                            <span class="mr-2">
                                <feather-icon icon="GlobeIcon"></feather-icon>
                                <a class="ml-25" :href="url">{{url}}</a>
                            </span>
                            <span>
                                <feather-icon icon="MailIcon"></feather-icon> 
                                <a class="ml-25" :href="`mailto:${mailAddress}`">{{mailAddress}}</a>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
export default {
    components:{
        BOverlay
    },
    data() {
        return {
            code:this.$route.params?.code || null,
            receipt:null,
            mailAddress:this.$param('company.account.email') || '-',
            url:this.$param('company.website.url') || '-',
            loading:false
        }
    },
    mounted(){
        this.getReceipt()
    },
    methods:{
        continuePayment(){
            this.$router.push({name:'payment',params:{code:this.receipt.GroupCode}})
        },
        getReceipt(){
            this.loading = true
            PaymentApi.GetReceipt(this.code).then(res=>{
                if(res.data.Success){
                    this.receipt = res.data.Data
                    if(this.receipt?.IsPaymentSuccessfull == false){
                        if(this.receipt.GroupCode && this.receipt.SystemReceiptCode){
                            this.$router.push({name:'payment-error',params:{groupCode:this.receipt.GroupCode,receiptCode:this.receipt.SystemReceiptCode}})
                        }else{
                            this.$router.push({name: 'error-404'})
                        }
                    }
                    this.loading = false
                }else this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        print(){
            window.print()
        } 
    },
    computed:{
        commissionAmount(){
            return this.receipt?.Details?.find(d => d.Status == 8)?.CommisionRate ? this.receipt?.Details?.find(d => d.Status == 8)?.CommisionAmount || null : null 
        }
    }
}
</script>

<style>
    .invoice {
        background: #fff;
        padding: 20px
    }

    .invoice-header {
        margin: 0 -20px;
        background: #f0f3f4;
        padding: 20px
    }

    .invoice-date,
    .invoice-from,
    .invoice-to {
        display: table-cell;
        width: 1%
    }

    .invoice-from,
    .invoice-to {
        padding-right: 20px
    }

    .invoice-date .date,
    .invoice-from strong,
    .invoice-to strong {
        font-size: 16px;
        font-weight: 600
    }

    .invoice-date {
        text-align: right;
        padding-left: 20px
    }

    .invoice-price {
        background: #f0f3f4;
        display: table;
        width: 100%
    }

    .invoice-price .invoice-price-left,
    .invoice-price .invoice-price-right {
        display: table-cell;
        padding: 20px;
        font-size: 20px;
        font-weight: 600;
        width: 75%;
        position: relative;
        vertical-align: middle
    }

    .invoice-price .invoice-price-left .sub-price {
        display: table-cell;
        vertical-align: middle;
        padding: 0 20px
    }

    .invoice-price small {
        font-size: 12px;
        font-weight: 400;
        display: block
    }

    .invoice-price .invoice-price-row {
        display: table;
        float: left
    }

    .invoice-price .invoice-price-right {
        width: 25%;
        background: #2d353c;
        color: #fff;
        font-size: 28px;
        text-align: right;
        vertical-align: bottom;
        font-weight: 300
    }

    .invoice-price .invoice-price-right small {
        display: block;
        opacity: .6;
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 12px
    }

    .invoice-footer {
        border-top: 1px solid #ddd;
        padding-top: 10px;
        font-size: 10px
    }

    .invoice-note {
        color: #999;
        margin-top: 80px;
        font-size: 85%
    }

    .invoice>div:not(.invoice-footer) {
        margin-bottom: 20px
    }
</style>